import { backend } from '@/services/backend'
import { DocGroupListItem } from './interfaces'

import { DocsListView } from './docs.list'
import { ListItemType, ListItem } from './interfaces'

/**
 * Podcasts logic used for listing page.
 */
export class PodcastsView implements DocsListView {
  public podcasts: DocGroupListItem[] = []

  constructor(podcasts: DocGroupListItem[]) {
    this.podcasts = podcasts
  }

  public get filteredDocs(): ListItem[] {
    return this.podcasts
  }

  public get dataLength(): number {
    return this.podcasts.length
  }

  public docTypeName(): ListItemType {
    return 'podcast'
  }

  setShowLimit(): void {
    // Not implemented for podcasts
  }

  isDocSortVisible(): boolean {
    return false
  }

  podcastSubtitle(podcast: DocGroupListItem): string {
    const count = podcast.doc_count
    return count + (count === 1 ? ' episode' : ' episodes')
  }

  hasFollowBadge(): boolean {
    return true
  }

  /**
   * Link for the podcast details (listing) page.
   */
  public startLinkParams(doc: ListItem): Record<string, unknown> {
    return {
      name: 'podcastPage',
      params: {
        url_slug: doc.url_slug,
      },
    }
  }

  /**
   * Create a new PodcastsView with search results for the given `searchTerm`.
   */
  static async createSearchView(searchTerm: string): Promise<PodcastsView> {
    // Note: other simiar methods (for example, ArticlesView) have an extra
    // `if (searchTerm)` check inside the method.
    //
    // In the UI the case where we don't have the searchTerm corresponds to the
    // "View All" link click on the search page for articles that opens the
    // `/app/articles/list/all` page.
    //
    // But for podcasts the "View All" just open the `/app/podcasts page` (and the
    // same for episodes). So we do not have the "/list/all" page for podcasts,
    // and do not need the `if (searchTerm)`
    //
    // I do not remember why exactly we do not have the `/list/all` page, and if
    // this was an intentional decision or just a shortcut for faster
    // implementation.
    const limit = 100
    const response = await backend.getPodcastSearch(searchTerm, limit)
    return new PodcastsView(response.slice(0, 4))
  }
}
